<mat-card class="playback-container compact" >
  <mat-card-content>
  <!-- Row 1: Duration, Seekbar, Play/Pause -->
  <div class="seekbar-row">
    <span class="duration">
      @if (audioLoaded()) {
        {{ formattedCurrentTime() }}
      } @else {
        {{ formattedDuration() }}
      }
    </span>

    <div class="progress-container" (click)="seekTo($event)">
      <div class="progress-bar">
        <div class="progress-fill" [style.width.%]="progress()"></div>
      </div>
    </div>

    <!-- Play/Pause button -->
    <button mat-icon-button
            class="play-button"
            [disabled]="loading()"
            (click)="togglePlayback()">
      @if (loading()) {
        <mat-spinner diameter="24"></mat-spinner>
      } @else if (playing()) {
        <mat-icon>pause_circle</mat-icon>
      } @else {
        <mat-icon>play_circle</mat-icon>
      }
    </button>
  </div>

  <!-- Row 2: Skip controls and transcript toggle (only when audio loaded) -->
  @if (audioLoaded()) {
    <div class="controls-row">
      <!-- Spacer to balance the transcript toggle -->
      <div class="spacer"></div>

      <!-- Skip backward 10s -->
      <button mat-icon-button
              (click)="skipBackward()"
              matTooltip="Back 10s">
        <mat-icon>replay_10</mat-icon>
      </button>

      <!-- Skip forward 10s -->
      <button mat-icon-button
              (click)="skipForward()"
              matTooltip="Forward 10s">
        <mat-icon>forward_10</mat-icon>
      </button>

      <!-- View transcript toggle -->
      <button mat-icon-button
              [disabled]="!hasTranscript()"
              (click)="toggleTranscript()"
              [matTooltip]="showTranscript() ? 'Hide transcript' : 'View transcript'">
        <mat-icon>{{ showTranscript() ? 'expand_less' : 'expand_more' }}</mat-icon>
      </button>
    </div>
  }

  <!-- Transcript text -->
  @if (showTranscript() && hasTranscript()) {
    <mat-divider></mat-divider>
    <div class="">
      <p class="transcript-text">{{ transcription().transcriptionText }}</p>
    </div>
  }
  </mat-card-content>
</mat-card>
